
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boards/[boardId]",
      function () {
        return require("private-next-pages/boards/[boardId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/boards/[boardId]"])
      });
    }
  